import http from '@/http'

// =====================
// LOCATIONS
// =====================

export async function fetchLocations (params = {}) {
  const response = await http.get('/admin/storage/locations', { params })
  return response.data
}

export async function fetchLocationsList () {
  const response = await http.get('/admin/storage/locations/list')
  return response.data
}

export async function createLocation (data) {
  const response = await http.post('/admin/storage/locations', data)
  return response.data
}

export async function updateLocation (id, data) {
  const response = await http.put(`/admin/storage/locations/${id}`, data)
  return response.data
}

export async function deleteLocation (id) {
  const response = await http.delete(`/admin/storage/locations/${id}`)
  return response.data
}

// =====================
// ITEM TYPES
// =====================

export async function fetchItemTypes (params = {}) {
  const response = await http.get('/admin/storage/item-types', { params })
  return response.data
}

export async function fetchItemTypesList () {
  const response = await http.get('/admin/storage/item-types/list')
  return response.data
}

export async function createItemType (data) {
  const response = await http.post('/admin/storage/item-types', data)
  return response.data
}

export async function updateItemType (id, data) {
  const response = await http.put(`/admin/storage/item-types/${id}`, data)
  return response.data
}

export async function deleteItemType (id) {
  const response = await http.delete(`/admin/storage/item-types/${id}`)
  return response.data
}

// =====================
// STORAGE ITEMS
// =====================

export async function fetchItems (params = {}) {
  const response = await http.get('/admin/storage/items', { params })
  return response.data
}

export async function fetchItemsByParticipant (participantId) {
  const response = await http.get(`/admin/storage/items/participant/${participantId}`)
  return response.data
}

export async function fetchItemByCode (code) {
  const response = await http.get(`/admin/storage/items/code/${code}`)
  return response.data
}

export async function fetchItemById (id) {
  const response = await http.get(`/admin/storage/items/${id}`)
  return response.data
}

export async function storeItem (data) {
  const response = await http.post('/admin/storage/items', data)
  return response.data
}

export async function returnItem (id, notes = null) {
  const response = await http.put(`/admin/storage/items/${id}/return`, { notes })
  return response.data
}

// =====================
// SCAN & STATS
// =====================

export async function scanParticipant (qrcode) {
  const response = await http.get(`/admin/storage/scan/${qrcode}`)
  return response.data
}

export async function scanParticipantByFacial (photo) {
  const response = await http.post('/admin/storage/scan/facial', { photo })
  return response.data
}

export async function fetchStats () {
  const response = await http.get('/admin/storage/stats')
  return response.data
}

// =====================
// PARTICIPANTS (for search)
// =====================

export async function fetchParticipants (params = {}) {
  const response = await http.get('/admin/check-in/participants', { params })
  return response.data
}
